<template>
  <td :class="tdClass" :colspan="colspan" :rowspan="rowspan">
    <slot></slot>
  </td>
</template>

<script>
export default {
  props: {
    css: {
      type: String,
      default: ''
    },
    model: Object,
    colspan: Number,
    rowspan: Number
  },

  computed: {
    tdClass: {
      get() {
        const arr = [this.css];

        if (this.model) {
          const vv = this.model.$value;
        }

        if (this.model && this.model.$error) {
          arr.push('state-error');
        } else {
          arr.push('state-success');
        }
        return arr;
      }
    }
  }
};
</script>
